export const jpCommunityForgotEmail = {
  CA60emailToChange: '変更するメールアドレス',
  CA60heading1: 'メールアドレス再設定のため、以下の項目を入力してください。秘密の質問をお忘れの場合は、',
  CA60heading2: 'お問い合わせフォームから',
  CA60heading3: 'ご連絡ください。',
  CA60sendConfirm: '確認用メールを送信する',
  CA62sent: '確認用のメールアドレスを送信しました。',
  CA60currentMail: '現在のメールアドレス',
}
